// Preview環境用にベースURLを取得（origin + BASE_URL）
const getDevelopersRedirectUrl = (redirectPath?: string) => {
  const { origin } = window.location;
  const basePath = process.env.BASE_URL ?? "";
  // redirectPathがある場合は末尾スラッシュを削除して結合、ない場合はそのまま
  if (redirectPath) {
    return `${origin}${basePath.replace(/\/$/, "")}${redirectPath}`;
  }
  return `${origin}${basePath}`;
};

// MypageログインURLを取得
// redirectPath: 指定した場合はそのパスをリダイレクト先に使用、省略時は現在のURLを使用
const getMypageLoginUrl = (redirectPath?: string) => {
  const mypageLoginUrl = process.env.VUE_APP_MYPAGE_LOGIN_URL;
  const developersUrl = getDevelopersRedirectUrl(redirectPath);
  return `${mypageLoginUrl}?redirectTo=${encodeURIComponent(developersUrl)}&appType=developers`;
};

const getMypageRegisterUrl = () => {
  const mypageRegisterUrl = process.env.VUE_APP_MYPAGE_REGISTER_URL;
  const developersUrl = getDevelopersRedirectUrl();
  return `${mypageRegisterUrl}?redirectTo=${encodeURIComponent(developersUrl)}&appType=developers`;
};

export { getMypageLoginUrl, getMypageRegisterUrl };
